// extracted by mini-css-extract-plugin
export default {"dotsBox":"styles_dotsBox__w4IAl","one":"styles_one__5+i+4","dot":"styles_dot__Tn5Af","two":"styles_two__JC-ny","three":"styles_three__lJ3SJ"};